export const currencySymbolMap = {
  KRW: '₩',
  JPY: '¥',
  TWD: 'NT$'
}

export const SUPPORT_MCP_CURRENCIES = {
  JPY: { symbol: '¥', decimalDigits: 0 },
  ARS: { symbol: 'ARS', decimalDigits: 2 },
  AUD: { symbol: 'AUD', decimalDigits: 2, isSuggested: true },
  BRL: { symbol: 'BRL', decimalDigits: 2 },
  CAD: { symbol: 'CAD', decimalDigits: 2 },
  CNY: { symbol: 'CNY', decimalDigits: 2, isSuggested: true },
  CZK: { symbol: 'CZK', decimalDigits: 2 },
  DKK: { symbol: 'DKK', decimalDigits: 2 },
  EUR: { symbol: '€', decimalDigits: 2, isSuggested: true },
  HKD: { symbol: 'HKD', decimalDigits: 2 },
  INR: { symbol: 'INR', decimalDigits: 2 },
  IDR: { symbol: 'IDR', decimalDigits: 0 },
  ILS: { symbol: 'ILS', decimalDigits: 2 },
  MOP: { symbol: 'MOP', decimalDigits: 2 },
  MYR: { symbol: 'MYR', decimalDigits: 2 },
  MXN: { symbol: 'MXN', decimalDigits: 2 },
  TWD: { symbol: 'NT$', decimalDigits: 0, isSuggested: true },
  NZD: { symbol: 'NZD', decimalDigits: 2 },
  NOK: { symbol: 'NOK', decimalDigits: 2 },
  PHP: { symbol: 'PHP', decimalDigits: 2 },
  GBP: { symbol: '£', decimalDigits: 2 },
  QAR: { symbol: 'QAR', decimalDigits: 2 },
  SAR: { symbol: 'SAR', decimalDigits: 2 },
  SGD: { symbol: 'SGD', decimalDigits: 2 },
  ZAR: { symbol: 'ZAR', decimalDigits: 2 },
  KRW: { symbol: '₩', decimalDigits: 0, isSuggested: true },
  LKR: { symbol: 'LKR', decimalDigits: 2 },
  SEK: { symbol: 'SEK', decimalDigits: 2 },
  CHF: { symbol: 'CHF', decimalDigits: 2 },
  THB: { symbol: 'THB', decimalDigits: 2 },
  AED: { symbol: 'AED', decimalDigits: 2 },
  USD: { symbol: '$', decimalDigits: 2, isSuggested: true },
  VND: { symbol: 'VND', decimalDigits: 0 },
  EGP: { symbol: 'EGP', decimalDigits: 2, searchable: false },
  KWD: { symbol: 'KWD', decimalDigits: 3, searchable: false },
  BHD: { symbol: 'BHD', decimalDigits: 3, searchable: false },
  OMR: { symbol: 'OMR', decimalDigits: 3, searchable: false }
}

export const CURRENCY_BY_BROWSER_LANGUAGE = {
  'de-AT': 'EUR',
  'fr-BE': 'EUR',
  'el-CY': 'EUR',
  'hr-HR': 'EUR',
  'et-EE': 'EUR',
  'fi-FI': 'EUR',
  'fr-FR': 'EUR',
  'de-DE': 'EUR',
  'el-GR': 'EUR',
  'en-IE': 'EUR',
  'it-IT': 'EUR',
  'lv-LV': 'EUR',
  'lt-LT': 'EUR',
  'fr-LU': 'EUR',
  'en-MT': 'EUR',
  'nl-NL': 'EUR',
  'pt-PT': 'EUR',
  'sk-SK': 'EUR',
  'sl-SI': 'EUR',
  'es-ES': 'EUR',
  'ja-JP': 'JPY',
  'en-US': 'USD',
  'ko-KR': 'KRW',
  'zh-Hant-TW': 'TWD',
  'zh-Hant-HK': 'HKD',
  'zh-Hans-CN': 'CNY',
  'zh-CN': 'CNY',
  'zh-TW': 'TWD',
  'en-SG': 'SGD',
  'ms-MY': 'MYR',
  'en-AU': 'AUD',
  'en-GB': 'GBP',
  'en-CA': 'CAD',
  'de-CH': 'CHF',
  'es-AR': 'ARS',
  'az-Latn-AZ': 'AZN',
  'bg-BG': 'BGN',
  'ar-BH': 'BHD',
  'pt-BR': 'BRL',
  'es-CL': 'CLP',
  'es-CO': 'COP',
  'cs-CZ': 'CZK',
  'da-DK': 'DKK',
  'ar-EG': 'EGP',
  'en-FJ': 'FJD',
  'ka-GE': 'GEL',
  'hu-HU': 'HUF',
  'id-ID': 'IDR',
  'he-IL': 'ILS',
  'hi-IN': 'INR',
  'is-IS': 'ISK',
  'ar-JO': 'JOD',
  'ar-KW': 'KWD',
  'ru-KZ': 'KZT',
  'ro-MD': 'MDL',
  'es-MX': 'MXN',
  'en-NA': 'NAD', // Namibia appears twice, but one uses ZAR (see below)
  'nb-NO': 'NOK',
  'en-NZ': 'NZD',
  'ar-OM': 'OMR',
  'pl-PL': 'PLN',
  'ar-QA': 'QAR',
  'ro-RO': 'RON',
  'ru-RU': 'RUB',
  'ar-SA': 'SAR',
  'sv-SE': 'SEK',
  'th-TH': 'THB',
  'tr-TR': 'TRY',
  'uk-UA': 'UAH',
  'fr-SN': 'XOF',
  'fr-CI': 'XOF',
  'fr-ML': 'XOF',
  'fr-NE': 'XOF',
  'fr-BF': 'XOF',
  'fr-BJ': 'XOF',
  'pt-GW': 'XOF',
  'fr-TG': 'XOF',
  'ar-AE': 'AED',
  'en-ZA': 'ZAR',
  'en-LS': 'ZAR',
  'en-SZ': 'ZAR'
}

export const CURRENCY_BY_BROWSER_LANGUAGE_SHORT = {
  de: 'EUR',
  fr: 'EUR',
  el: 'EUR',
  hr: 'EUR',
  et: 'EUR',
  fi: 'EUR',
  en: 'USD',
  it: 'EUR',
  lv: 'EUR',
  lt: 'EUR',
  nl: 'EUR',
  pt: 'EUR',
  sk: 'EUR',
  sl: 'EUR',
  es: 'EUR',
  ja: 'JPY',
  ko: 'KRW',
  zh: 'CNY',
  ms: 'MYR',
  az: 'AZN',
  bg: 'BGN',
  ar: 'AED',
  cs: 'CZK',
  da: 'DKK',
  ka: 'GEL',
  hu: 'HUF',
  id: 'IDR',
  he: 'ILS',
  hi: 'INR',
  is: 'ISK',
  ru: 'RUB',
  ro: 'RON',
  nb: 'NOK',
  pl: 'PLN',
  sv: 'SEK',
  th: 'THB',
  tr: 'TRY',
  uk: 'UAH'
}

export const BW_LOCALE_TO_CURRENCY = {
  ja: 'JPY',
  en: 'USD',
  zh_Hant: 'TWD',
  zh_Hans: 'CNY',
  ko: 'KRW',
  th: 'THB',
  id: 'IDR',
  ar: 'AED'
}
